import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux';
import { DateTime } from 'luxon';
import { toast } from 'react-toastify';
import $, { param } from 'jquery'
import bootbox from 'bootbox'
import { Modal, ModalBody, ModalHeader, Table } from 'reactstrap'

import { loadable } from '../../Layout/Common/Loadable';
import HierarchySelection from '../../Layout/HierarchySelection'
import { generateAudit, getAudit, getAuditsBySite } from '../../../utils/Audits';
import AuditTable from './AuditTable';
import { getRecommendationDefinitions, getRecommendations, MANUAL_INSIGHTS } from '../../../utils/Recommendations';
import Skeleton from 'react-loading-skeleton';
import SkeletonTable from '../../Layout/Loaders/SkeletonTable';
import SkeletonAuditCard from '../../Layout/Loaders/SkeletonAuditCard';
const AuditCard = loadable(() => import('./AuditCard'));

const INITIAL_STATE = {
    siteId: null,
    lastEvalKey: null,
    modal: false,
    allLoaded: false,
    metricsLoaded: false,
    metricsLoading: false,
    allRecommendations: [],
    disabled: false,
    auditItems: [],
    radialGraph: {
        series: [40],
        options: {
            chart: {
                height: 200,
                width: 200,
                type: 'radialBar'
            },
            plotOptions: {
                radialBar: {
                    hollow: {
                        size: '60%',
                    },
                    track: {
                        background: "#e7e7e7",
                        strokeWidth: '97%'
                    },
                    dataLabels: {
                        show: true,
                        name: {
                            show: true,
                            color: '#888',
                            fontSize: '20px'
                        },
                        value: {
                            offsetY: -10,
                            formatter: function(val) {
                                return val + "%";
                            },
                            color: '',
                            fontSize: '26px',
                            show: true,
                        }
                    }
                },
            },
            fill: {
                colors: []
            },
            labels: ['']
        }
    }
}

function Audits(){

    const [state, setState] = useState(INITIAL_STATE)
    const model = useSelector(state => state.site.model)
    const session = useSelector(state => state.session)
    const isAdmin = useSelector(state => state.session.isAdmin)

    const onSelection = async(__, token, meta) => {
        await setState(prevState => ({
            ...prevState,
            token,
            siteId: meta.siteId
        }))
        const results = await getAuditsBySite(token, meta.siteId)
        return results
    }

    const onSelectionComplete = async(results) => {

        const { response, error } = results

        if(error){
            await setState(prevState => ({
                ...prevState,
                metricsLoaded: true,
                auditItems: []
            }))
        } else {
            let prevMetrics = {}
            let insights = {}
            if(response.audits.length > 0){
                const a = await getAudit(null, response.audits[0].auditId)
                insights = await getRecommendations(response.audits[0].siteId, response.audits[0].yearMonth)
                    .then(r => r.response?.result ?? {})
                if(a.response){
                    prevMetrics = a.response.prevMetrics
                }
            }
            
            
            await setState(prevState => ({
                ...prevState,
                metricsLoaded: true,
                metricsLoading: false,
                auditItems: response.audits,
                insights,
                prevMetrics,
                lastEvalKey: response.lastEvalKey,
                allLoaded: response.lastEvalKey ? false : true
            }))
        }

    }

    const loadMoreAudits = async() => {
        const { token, lastEvalKey, siteId } = state
        const { response, error } = await getAuditsBySite(token, siteId, lastEvalKey)

        await setState(prevState => ({
            ...prevState,
            auditItems: [...prevState.auditItems, ...response.audits],
            lastEvalKey: response.lastEvalKey,
            allLoaded: response.lastEvalKey ? false : true
        }))
    }

    const onGenerateBaselineAudit = async(startDate=null, endDate=null) => {
        setState(prev => ({
            ...prev,
            disabled: true
        }))
        const body = {
            yearMonth: DateTime.local().minus({months: 1}).toFormat("yyyyMM"),
            overrideType: "baseline"
        }

        if(startDate !== null){
            body.startDate = startDate
        }

        if(endDate !== null){
            body.endDate = endDate            
        }

        const { response, error } = await generateAudit(state.siteId, body)
        setState(prev => ({
            ...prev,
            disabled: false
        }))

        if(response){
            const res = await onSelection(null, session.token, {
                siteId: state.siteId
            })

            await onSelectionComplete(res)
        } else {
            toast.error("Error: Baseline audit was not generated")
        }
    }

    const overrideBaselineDates = () => {
        bootbox.prompt({
            title: "What is the baseline audit start date?",
            inputType: 'date',
            callback: function (result) {

                const sDate = result
                bootbox.prompt({
                    title: "What is the baseline audit end date?",
                    inputType: 'date',
                    callback: function (res) {
                        const eDate = res

                        onGenerateBaselineAudit(sDate, eDate)
                    }
                })
            }
        });
    }

    const toggleModal = () => {
        setState(prev => ({
            ...prev,
            modal: !state.modal
        }))
    }

    useEffect(() => {
        if(state.metricsLoaded){
            $("#collapse-history").trigger("click")
        }
    }, [state.metricsLoaded])

    useEffect(() => {

        const allRecommendations = []

        getRecommendationDefinitions().then(({response}) => {
            allRecommendations.push(...response.recommendations)
        })

        allRecommendations.push(...MANUAL_INSIGHTS)
        setState(prevState => ({
            ...prevState,
            allRecommendations
        }))
    }, [])


    const {
        metricsLoaded,
        metricsLoading,
        auditItems,
        allLoaded,
        prevMetrics,
        disabled,
        insights,
        allRecommendations
    } = state

    return <>
        <h1 className="page-header">Audits &amp; Insights</h1>

        <HierarchySelection hideInputs={{period:true}}
            onSelectionBegin={() => setState(prevState => ({...prevState, metricsLoading: true, metricsLoaded: false}))} 
            overrideOnSelection={(dataPath, token, meta) => onSelection(dataPath, token, meta)} 
            onSelectionComplete={(overrideResult) => onSelectionComplete(overrideResult)}
             />
        {(metricsLoading || metricsLoaded) && <>
            {isAdmin && <div class="row justify-content-end">
                <div class="col-lg-4 col-sm-6 col-12">
                    <div class="btn-group float-right">
                        {metricsLoaded ? <>
                            <button className="btn btn-lg btn-primary" disabled={disabled} onClick={() => onGenerateBaselineAudit()}>Generate Baseline</button>
                            <button type="button" class="btn btn-primary btn-lg dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <span class="sr-only">Toggle Dropdown</span>
                            </button>
                            <div class="dropdown-menu">
                                <a class="dropdown-item" href="javascript::;" onClick={() => overrideBaselineDates()}>Override Baseline Dates</a>
                            </div>
                            <button className="btn btn-lg btn-info" onClick={() => toggleModal()}>
                                <i className="fas fa-question-circle"></i>
                            </button>
                        </> : <>
                            <Skeleton inline height={40} width={150} />
                            <Skeleton inline height={40} width={40} />
                        </>}
                    </div>
                </div>
            </div>}
            <div className="row">
                <div class="col-xl-3 col-lg-12 col-12">
                    <div class="panel panel-inverse">
                        <div class="panel-heading">
                            <div class="panel-heading-btn">
                                <a href="javascript:;" class="btn btn-xs btn-icon btn-circle btn-default" data-click="panel-expand"><i class="fa fa-expand"></i></a>
                                <a href="javascript:;" class="btn btn-xs btn-icon btn-circle btn-success" data-click="panel-reload"><i class="fa fa-redo"></i></a>
                                <a href="javascript:;" class="btn btn-xs btn-icon btn-circle btn-warning" data-click="panel-collapse" id="collapse-history"><i class="fa fa-minus"></i></a>
                            </div>
                            <h4 class="panel-title">
                                Audit History
                            </h4>
                        </div>
                        <div class="panel-body">
                            {metricsLoaded ? <AuditTable audits={auditItems} allLoaded={allLoaded} onLoadMoreAudits={() => loadMoreAudits()} /> : <SkeletonTable rows={5} columns={4} headerRow={<tr>
                                <th>Date Created</th>
                                <th>Period</th>
                                <th>Audit Score</th>
                                <th>Status</th>
                            </tr>} />}
                        </div>
                    </div>
                </div>
                <div class="col-xl-9 col-lg-12 col-12">
                    <div class="panel panel-inverse">
                        <div class="panel-heading">
                            <div class="panel-heading-btn">
                                <a href="javascript:;" class="btn btn-xs btn-icon btn-circle btn-default" data-click="panel-expand"><i class="fa fa-expand"></i></a>
                                <a href="javascript:;" class="btn btn-xs btn-icon btn-circle btn-success" data-click="panel-reload"><i class="fa fa-redo"></i></a>
                                <a href="javascript:;" class="btn btn-xs btn-icon btn-circle btn-warning" data-click="panel-collapse"><i class="fa fa-minus"></i></a>
                            </div>
                            <h4 class="panel-title">
                                Recent Audit and Insights
                            </h4>
                        </div>
                        <div class="panel-body">
                            {metricsLoaded ? auditItems.length > 0 ? <AuditCard 
                                version={auditItems[0].version ?? 1} 
                                insights={insights} 
                                prevMetrics={prevMetrics} audit={auditItems[0] ? auditItems[0] : null} 
                                site={model.sites[model.siteActiveIdx]} /> : <></> :
                            <SkeletonAuditCard sections={8} itemsPerSection={2} />}
                        </div>
                    </div>
                </div>
            </div>
            {metricsLoaded && <Modal isOpen={state.modal} toggle={toggleModal}>
                <ModalHeader>Available Insights &amp; Recommendations</ModalHeader>
                <ModalBody>
                    <div class="bg-white mb-2">
                        <div class="note-content text-end">
                            <div className="row">
                                {allRecommendations.length > 0 && allRecommendations.map(i => <div className="col-sm-6 col-12 p-10">
                                    <img src={i.icon} style={{ width: "40px", height: "40px" }} /> <strong className="ml-2">{i.title}</strong>
                                </div>)}
                            </div>
                        </div>
                    </div>
                </ModalBody>
            </Modal>}
        </>
        }
    </>
}

export default Audits